module.exports = __webpack_public_path__ + "assets/advert.6bd73bdf.svg";